<template>
  <v-app>
    <UserNavBar/>
    <v-main>
      <v-container>        
        <router-view />
      </v-container>
    </v-main> 
  </v-app>

</template>

<script>
import UserNavBar from '@/components/user/UserNavBar.vue'

export default {
  name: 'UserLayout',
  data() {
    return {      
    }
  },  
  components: {
    UserNavBar
  },
  // computed: {
  //   hideMenu() {
  //     // Hide menu if route is /evaluation or starts with /evaluation/
  //     return this.$route.name === 'EvaluationView' || this.$route.path.startsWith('/evaluation');
  //   }
  // }
}
</script>

<style>
.v-app {
  min-height: 100vh;
}
</style>